import { colors } from "@/app/Colors";
import { Email, FilledLocationIcon, PhoneIcon } from "@/utlility/icons";
import Link from "next/link";
import React from "react";


const ContactCard = ({ addressData }) => (
  <>
    <div className="d-flex contact-card gap-2 gap-sm-3 ">
      <i className="icon">
        <PhoneIcon color={colors["--icon"]} />
      </i>
      <div className="text-content">
        <Link href={`tel:${addressData?.phone_number}`} target="_blank" style={{ textDecoration: "none" }}>
          <h4 className="contact-type fw-medium">Call / SMS</h4>
          <p className="card-description fw-medium">
            {`+91 ${addressData?.phone_number}`}
          </p>
        </Link>
      </div>
    </div>
    <div className="d-flex contact-card gap-2 gap-sm-3 ">
      <i className="icon">
        <Email color={colors["--icon"]} />
      </i>
      <div className="text-content">
        <Link href={`mailto:${addressData?.email}`} target="_blank">
          <h4 className="contact-type fw-medium">Email</h4>
          <p className="card-description fw-medium">{addressData?.email}</p>
        </Link>
      </div>
    </div>
    <div className="d-flex contact-card gap-2 gap-sm-3 ">
      <i className="icon">
        <FilledLocationIcon color={colors["--icon"]} />
      </i>
      <div className="text-content">
        <Link href={`${addressData?.map_location}`} target="_blank">
          <h4 className="contact-type fw-medium">Location</h4>
          <p className="card-description fw-medium">{addressData?.address}</p>
        </Link>
      </div>
    </div>
  </>
)

export default ContactCard;
